import React, { Component } from 'react';
import cx from 'classnames';
import UserAPI from '../../apis/UserAPI';
import config from '../../../../conf';
import styles from './sing-up.module.scss';
import queryString from 'query-string';

import Nav from '../../common/component/Nav/Nav';
import MainContainer from '../../common/component/MainContainer';
import FormContainer from '../../common/component/FormContainer';
import Footer from '../../common/component/Footer';
import { CustomInput } from '../../../engage/components/Input/Input';
import { CustomButton } from '../../../engage/components/Button/Button';
import MobileHeader from '../../../engage/components/MobileHeader';
import MobilePasswordCheck from '../../common/component/MobilePasswordCheck/MobilePasswordCheck';
import RadioButton from '../../../engage/components/RadioButton/RadioButton';
import ProtectedPageSidebar from '../../../engage/components/Sidebar/ProtectedPageSidebar';
import { withTranslation } from 'react-i18next';
import { isLoggedIn } from '../../../engage/utils/auth-util';
import AuthorizationService from '../../../engage/service/AuthorizationService';

class SignUpPage extends Component {
  constructor() {
    super();
    this.state = {
      isSignUpFormFilled: false,
      code: '',
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: '',
      loading: false,
      emailError: false,
      emailErrorMsg: 'This email is not valid. Please use a different one.',
      showPassword: false,
      reqTenChars: false,
      reqUpperCase: false,
      reqLowerCase: false,
      reqSymbol: false,
      reqNumber: false,
      isMobileView: false,
      isFieldError: {
        password: false,
        confirmPassword: false,
        firstName: false,
        lastName: false,
      },
      genericErrorMessage: {
        password: '',
        confirmPassword: '',
        firstName: '',
        lastName: '',
      },
      isAgree: false,
    };
  }

  async componentDidMount() {
    const mediaMatch = window.matchMedia('(max-width: 900px)');
    this.setState({ isMobileView: mediaMatch.matches });
    this.props.location.state?.email && this.setState({ email: this.props.location.state.email });
    /*
     * We cannot fully implement the registration of a new user in the desktop application,
     * since when creating a new account, confirmations are sent to the email
     * and the links in them will still lead to the web application.
     * Therefore, if the user in the desktop application entered a login that does not exist,
     * then he will be redirected here for a second attempt where he can register
     *
     * If there is a search param "desktopEmail",
     * the application will be able to understand that the user was redirected from the desktop application.
     *
     * But in this case, the old account must be logged out so that the new one can register,
     * so we are forced to log out the user in case he was logged in
     */
    const searchWithPlusSign = this.props.location.search.replaceAll('+', '%2B');
    const { desktopEmail } = queryString.parse(searchWithPlusSign);

    if (desktopEmail) {
      const firstUserCheck = await isLoggedIn();

      if (firstUserCheck) {
        await AuthorizationService.logOut(desktopEmail);
      }

      this.setState({ email: desktopEmail });
      return;
    }

    const userCheck = await isLoggedIn();

    // Redirect to the dashboard if user already logged in or if the url was entered directly
    // (without a redirect from the login page where the email domain is checked and,
    // if successful, the email will be in location state)
    if (userCheck || !this.props.location.state?.email) {
      this.props.history.push('/eg/home');
    }
  }

  onFormChange = e => {
    const { isFieldError, genericErrorMessage } = this.state;
    const name = e.target.name;
    const value = e.target.value;

    // Validate input on change
    if (name === 'firstName' && value.length > 3) {
      isFieldError[name] = false;
      genericErrorMessage[name] = '';
      this.setState({ isFieldError, genericErrorMessage });
    }

    if (name === 'lastName' && value.length > 3) {
      isFieldError[name] = false;
      genericErrorMessage[name] = '';
      this.setState({ isFieldError, genericErrorMessage });
    }

    if (name === 'password') {
      // At least 10 characters
      if (value.length >= config.general.minPasswordLength) {
        this.setState({ reqTenChars: true });
      } else {
        this.setState({ reqTenChars: false });
      }

      // At least one lowercase character
      if (/(?=.*[a-z])/.test(value)) {
        this.setState({ reqLowerCase: true });
      } else {
        this.setState({ reqLowerCase: false });
      }

      // At least one uppercase character
      if (/(?=.*[A-Z])/.test(value)) {
        this.setState({ reqUpperCase: true });
      } else {
        this.setState({ reqUpperCase: false });
      }

      // At least one symbol
      if (/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)) {
        this.setState({ reqSymbol: true });
      } else {
        this.setState({ reqSymbol: false });
      }

      // At least one number
      if (/\d/.test(value)) {
        this.setState({ reqNumber: true });
      } else {
        this.setState({ reqNumber: false });
      }
    }

    this.setState({ [name]: value });
  };

  onEmailEnter = async e => {
    const email = e.target.value.trim();
    this.setState({ email });
    this.setState({ emailError: false });
  };

  onEmailBlur = () => {
    if (this.state.email && !this.validateEmailFormat(this.state.email)) {
      this.setState({ emailError: true });
    } else {
      this.setState({ emailError: false });
    }
  };

  validateEmailFormat = emailAddress => {
    // eslint-disable-next-line no-useless-escape
    const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(emailAddress);
  };

  handleAgreeChecked = () => {
    this.setState(prevState => ({ ...prevState, isAgree: !prevState.isAgree }));
  };

  nextStep = async () => {
    // Sign-up form is being submitted here
    this.setState({ loading: true });

    const { isFieldError, genericErrorMessage } = this.state;
    const email = this.state.email;

    // Fields are validated
    if (!this.state.firstName) {
      console.log(this.state);
      isFieldError.firstName = true;
      genericErrorMessage.firstName = 'First name should not be empty';
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (!this.state.isMobileView && !this.state.lastName.trim()) {
      isFieldError.lastName = true;
      genericErrorMessage.lastName = 'Last name should not be empty';
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (!this.state.password) {
      isFieldError.password = true;
      genericErrorMessage.password = 'Password is mandatory.';
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (this.state.password.length < config.general.minPasswordLength) {
      isFieldError.password = true;
      genericErrorMessage.password = `${this.props.t('general.password.requirement_one')} ${config.general.minPasswordLength}${' '}
      ${this.props.t('general.password.requirement_one_characters')}`;
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (!this.state.reqLowerCase || !this.state.reqUpperCase || !this.state.reqSymbol || !this.state.reqNumber) {
      isFieldError.password = true;
      if (!this.state.reqLowerCase || !this.state.reqUpperCase)
        genericErrorMessage.password = this.props.t('general.password.requirement_two');
      if (!this.state.reqSymbol) genericErrorMessage.password = this.props.t('general.password.requirement_three');
      if (!this.state.reqNumber) genericErrorMessage.password = this.props.t('general.password.requirement_four');
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (!this.state.isMobileView && this.state.password !== this.state.confirmPassword) {
      isFieldError.password = true;
      genericErrorMessage.password = 'Passwords should match.';
      this.setState({ isFieldError, genericErrorMessage, loading: false });
      return;
    }

    if (!this.validateEmailFormat(email)) {
      this.setState({ emailError: true, loading: false });
      return;
    }

    isFieldError.password = false;
    isFieldError.firstName = false;
    isFieldError.lastName = false;
    genericErrorMessage.password = '';
    genericErrorMessage.firstName = '';
    genericErrorMessage.lastName = '';
    this.setState({ isFieldError, genericErrorMessage });

    // Register the user in the CMS
    try {
      // Is email available?
      const isAvailable = await UserAPI.isEmailAvailable(this.state.email);
      if (isAvailable) {
        console.log('user will be created');
        // Sign up the user
        const fullName = `${this.state.firstName} ${this.state.lastName}`;
        await UserAPI.signUp(fullName.trim(), this.state.email, this.state.password);
        this.props.history.push(`/confirm-email?email=${encodeURIComponent(this.state.email)}`); // Redirect to email confirmation flow
      } else {
        throw 'This email address is not available.';
      }
    } catch (error) {
      console.log('Failed to create user:', error);
      this.setState({ emailError: true, emailErrorMsg: error, loading: false });
    }
  };

  viewPassword = () => {
    this.setState({ showPassword: true });
  };

  maskPassword = () => {
    this.setState({ showPassword: false });
  };

  render() {
    const {
      emailError,
      emailErrorMsg,
      showPassword,
      isFieldError,
      genericErrorMessage,
      loading,
      reqTenChars,
      reqLowerCase,
      reqUpperCase,
      reqSymbol,
      reqNumber,
      isMobileView,
      isAgree,
    } = this.state;

    // const disabled= (!this.state.email || emailError || !this.state.password || !this.state.confirmPassword || !this.state.firstName || !this.state.lastName);

    return (
      <>
        {!isMobileView && <Nav />}
        <MobileHeader libraryMode={false} />
        <MainContainer className={cx('content-padding play-bg', { [styles.clearBackground]: isMobileView })}>
          {isMobileView && <ProtectedPageSidebar />}
          <div>
            <div>
              <FormContainer title="Welcome. Who are you?" className={styles.formHeader}>
                <div className={styles.formContainer}>
                  <div className={cx(styles.authCard, styles.singUp)}>
                    {isMobileView && (
                      <CustomInput
                        name="firstName"
                        fieldName="Name"
                        value={this.state.firstName}
                        placeholder="Your name"
                        invalid={isFieldError.firstName}
                        validateMessage={genericErrorMessage.firstName}
                        onChange={event => this.onFormChange(event)}
                      />
                    )}
                    <CustomInput
                      type="email"
                      name="email"
                      placeholder="Your email address"
                      fieldName="Email address"
                      invalid={emailError}
                      validateMessage={emailErrorMsg}
                      onChange={event => this.onEmailEnter(event)}
                      onFocusChanged={this.onEmailBlur}
                      value={this.state.email}
                    />
                    {!isMobileView && (
                      <div className={cx(styles.inputsContainer, { [styles.withError]: isFieldError.firstName })}>
                        <CustomInput
                          name="firstName"
                          fieldName="First name"
                          placeholder="Your first name"
                          value={this.state.firstName}
                          invalid={isFieldError.firstName}
                          validateMessage={genericErrorMessage.firstName}
                          onChange={event => this.onFormChange(event)}
                          customStyles={{ marginRight: '12px' }}
                        />
                        <CustomInput
                          name="lastName"
                          fieldName="Last Name"
                          placeholder="Your last Name"
                          value={this.state.lastName}
                          invalid={isFieldError.lastName}
                          validateMessage={genericErrorMessage.lastName}
                          onChange={event => this.onFormChange(event)}
                          customStyles={{ marginLeft: '12px' }}
                        />
                      </div>
                    )}
                    <div className={cx(styles.inputsContainer, { [styles.withError]: isFieldError.firstName })}>
                      <CustomInput
                        isShow
                        id="password"
                        type="password"
                        name="password"
                        value={this.state.password}
                        fieldName="Password"
                        placeholder="Your password"
                        invalid={isFieldError.password}
                        onChange={event => this.onFormChange(event)}
                        customStyles={{ marginRight: isMobileView ? '0' : '12px' }}
                      />
                      {!isMobileView && (
                        <CustomInput
                          isShow
                          id="confirmPassword"
                          type="password"
                          name="confirmPassword"
                          fieldName="Confirm Password"
                          placeholder="Your password"
                          value={this.state.confirmPassword}
                          invalid={isFieldError.password}
                          validateMessage={genericErrorMessage.password}
                          onChange={event => this.onFormChange(event)}
                          customStyles={{ marginLeft: '12px' }}
                        />
                      )}
                    </div>
                    {isMobileView ? (
                      <MobilePasswordCheck
                        isUpperCase={reqUpperCase}
                        isLowerCase={reqLowerCase}
                        isOneNumber={reqNumber}
                        isSymbol={reqSymbol}
                        isMinLength={reqTenChars}
                      />
                    ) : (
                      !(reqTenChars && reqLowerCase && reqUpperCase && reqSymbol && reqNumber) && (
                        <div className={cx(styles.passwordRequirements, styles.requirementsList)}>
                          <ul>
                            {!reqTenChars && (
                              <li className="pw-requirement">
                                {this.props.t('general.password.requirement_one')} {config.general.minPasswordLength}{' '}
                                {this.props.t('general.password.requirement_one_characters')}
                              </li>
                            )}
                            {!(reqLowerCase && reqUpperCase) && (
                              <li className="pw-requirement">{this.props.t('general.password.requirement_two')}</li>
                            )}
                            {!reqSymbol && <li className="pw-requirement">{this.props.t('general.password.requirement_three')}</li>}
                            {!reqNumber && <li className="pw-requirement">{this.props.t('general.password.requirement_four')}</li>}
                          </ul>
                        </div>
                      )
                    )}

                    <div className={styles.termsContainer}>
                      {isMobileView && (
                        <RadioButton
                          checked={isAgree}
                          onChange={this.handleAgreeChecked}
                          label=""
                          id={'agree'}
                          variant="secondary"
                          className={styles.radioButton}
                        />
                      )}
                      <span>By continuing you agree to our</span>
                      <a href="https://vormats.com/terms-conditions/" title="Terms of Service" className={styles.link} target="blank">
                        Terms of Service.
                      </a>
                    </div>

                    <CustomButton
                      className={styles.submitButton}
                      variant="primary"
                      onClick={this.nextStep}
                      loading={loading}
                      loadingText="Signing up..."
                      disabled={
                        !this.state.email ||
                        emailError ||
                        !this.state.password ||
                        (isMobileView ? false : !this.state.confirmPassword) ||
                        !this.state.firstName ||
                        (isMobileView ? false : !this.state.lastName) ||
                        (isMobileView ? !isAgree : false)
                      }
                    >
                      Continue
                    </CustomButton>
                  </div>
                </div>
              </FormContainer>
            </div>
          </div>
        </MainContainer>
        <Footer />
      </>
    );
  }
}

export default withTranslation()(SignUpPage);
